<template>
  <div v-title data-title="询价文件管理系统" id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
}

.center_box {
  display: flex;
  justify-content: center;
  align-items: center;
}

.center_heng {
  display: flex;
  justify-content: center;
}

.center_shu {
  display: flex;
  align-items: center;
}

.xiaoshou {
  cursor: pointer;
}
</style>
